import Cookies from "js-cookie"

class Account {
    static setData(data){
        localStorage.setItem('id',data.id)
        localStorage.setItem('user_id',data.user_id || data.user?.id)
        Cookies.set('id',data.id)
        Cookies.set('user_id',data.user_id)
    }

    static getData(){
        return {id:localStorage.getItem('id') || Cookies.get('id'),user_id:localStorage.getItem('user_id')|| Cookies.get('user_id'),profession:localStorage.getItem('profession')|| Cookies.get('profession'),}

    }
    static getToken() {
        return localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    }

    static logoutAdmin() {
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('user_id');
        localStorage.removeItem('profession');

    }
}

export default Account;
